<template>
  <div>
    <v-card-title class="justify-space-between">
      {{ video.title }}
      <v-checkbox v-if="Selectable" :input-value="value"
                  class="pa-0 ma-0" color="success" dense hide-details readonly/>
    </v-card-title>
    <iframe :src="video.file_link" style="max-width: 100%;height: auto"/>
    <v-card-actions class="justify-space-between align-start">
      {{ video.description }}
      <v-btn v-if="showDelete" :loading="loading" icon @click.stop="$emit('delete', video.id)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  name: "videoSelectorCard",

  props: {
    value: Boolean,
    video: Object,
    loading: Boolean,
    showDelete: Boolean,
    Selectable: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

</style>